import { ListTaxiparksUnAuth } from '~/features/Taxiparks'
import { PageContainer } from '~/shared/ui/PageContainer'
import { myPalette } from '~/shared/ui/theme'

type ListTaxiparksUnAuthPageProps = {
  isManualRegistration?: boolean
}

export function ListTaxiparksUnAuthPage({
  isManualRegistration = false,
}: ListTaxiparksUnAuthPageProps) {
  return (
    <PageContainer
      canBack
      backTitle='Таксопарк'
      title='Таксопарк'
      topContent={
        <div
          style={{
            color: myPalette.aliceBlue.main,
            fontSize: '18px',
            fontWeight: 700,
          }}
        >
          Выберите таксопарк, в котором хотите зарегистрироваться
        </div>
      }
    >
      <ListTaxiparksUnAuth isManualRegistration={isManualRegistration} />
    </PageContainer>
  )
}
